/* eslint-disable react/jsx-filename-extension */
// @ts-nocheck
import React from 'react';
// material
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import ButtonWithLoader from '../../../../commons/containers/ButtonWithLoader';
import colors from '../../../../utils/colors';

const useStyles = makeStyles(() => ({
  input: {
    color: colors.grey,
  },
}));

const ModalForm = (props) => {
  const {
    isOpen, edit, controls, changeControls, invalidControls, submit, users,
  } = props;
  const classes = useStyles();

  const userList = users ? Object.values(users) : [];

  return (
    <Dialog
      fullWidth
      onClose={() => props.actions.toggleForm('formIsOpen')}
      aria-labelledby="simple-dialog-title"
      open={isOpen}
    >
      <DialogTitle>{`${edit ? 'Editar' : 'Crear'} formulario`}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.name}
              onChange={changeControls}
              fullWidth
              id="name"
              label="Nombre"
              error={invalidControls.name}
              helperText={invalidControls.name && 'Debe ingresar un nombre'}
              onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
              inputProps={{ className: classes.input }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormControl fullWidth>
              <InputLabel>Usuario de notificaci&oacute;n (opcional)</InputLabel>
              <Select
                value={controls.notificationUserId || ''}
                onChange={(e) => props.actions.changeControls({ notificationUserId: e.target.value || '' })}
              >
                <MenuItem value="">
                  <em>Sin notificaci&oacute;n</em>
                </MenuItem>
                {userList.map((user) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.email}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Se enviar&aacute; una notificaci&oacute;n a este usuario cuando alguien complete el formulario</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.actions.toggleForm('formIsOpen')} color="primary" variant="outlined">
          Cancelar
        </Button>
        <ButtonWithLoader onClick={submit} autoFocus buttonId="create-edit-form">
          {edit ? 'Editar' : 'Agregar'}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
};

export default ModalForm;
